var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 0.333984C6.63148 0.333984 6.33301 0.632461 6.33301 1.00065V3.00065C6.33301 3.36884 6.63148 3.66732 6.99967 3.66732C7.36786 3.66732 7.66634 3.36884 7.66634 3.00065V1.00065C7.66634 0.632461 7.36786 0.333984 6.99967 0.333984Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 10.334C6.63148 10.334 6.33301 10.6325 6.33301 11.0007V13.0007C6.33301 13.3688 6.63148 13.6673 6.99967 13.6673C7.36786 13.6673 7.66634 13.3688 7.66634 13.0007V11.0007C7.66634 10.6325 7.36786 10.334 6.99967 10.334Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 6.33398C13.3679 6.33398 13.6663 6.63246 13.6663 7.00065C13.6663 7.36884 13.3679 7.66732 12.9997 7.66732H10.9997C10.6315 7.66732 10.333 7.36884 10.333 7.00065C10.333 6.63246 10.6315 6.33398 10.9997 6.33398H12.9997Z",
    fill: "#777E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66634 7.00065C3.66634 6.63246 3.36786 6.33398 2.99967 6.33398H0.999674C0.631485 6.33398 0.333008 6.63246 0.333008 7.00065C0.333008 7.36884 0.631485 7.66732 0.999674 7.66732H2.99967C3.36786 7.66732 3.66634 7.36884 3.66634 7.00065Z",
    fill: "#777E91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7709 2.28667C11.0313 2.02632 11.4534 2.02632 11.7138 2.28667C11.9741 2.54702 11.9741 2.96913 11.7138 3.22948L10.2995 4.64369C10.0392 4.90404 9.61708 4.90404 9.35673 4.64369C9.09638 4.38334 9.09638 3.96123 9.35673 3.70088L10.7709 2.28667Z",
    fill: "#777E91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64263 9.35764C4.38228 9.09729 3.96017 9.09729 3.69982 9.35764L2.28561 10.7718C2.02526 11.0322 2.02526 11.4543 2.28561 11.7147C2.54596 11.975 2.96807 11.975 3.22842 11.7147L4.64263 10.3004C4.90298 10.0401 4.90298 9.61798 4.64263 9.35764Z",
    fill: "#777E91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7137 10.7719C11.9741 11.0323 11.9741 11.4544 11.7137 11.7147C11.4534 11.9751 11.0313 11.9751 10.7709 11.7147L9.35671 10.3005C9.09636 10.0402 9.09636 9.61806 9.35671 9.35771C9.61706 9.09736 10.0392 9.09736 10.2995 9.35771L11.7137 10.7719Z",
    fill: "#777E91"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64269 4.64361C4.90304 4.38326 4.90304 3.96115 4.64269 3.7008L3.22848 2.28658C2.96813 2.02623 2.54602 2.02623 2.28567 2.28658C2.02532 2.54693 2.02532 2.96904 2.28567 3.22939L3.69988 4.64361C3.96023 4.90395 4.38234 4.90395 4.64269 4.64361Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.e690f60846e78623714d90910987f2c9.svg";
export { ForwardRef as ReactComponent };